




















































import { Component, Mixins } from "vue-property-decorator";
import HasValidation from "@/mixins/HasValidation";
import { IImport, IImportSource } from "@/models/imports";
import { DataModules } from "@/store/modules/data";

@Component({
  components: {
    "import-source-select": () =>
      import("@/components/app/admin/imports/importSourceSelect.vue"),
    "source-credentials-select": () =>
      import("@/components/app/admin/imports/sourceCredentialsSelect.vue")
  }
})
export default class NewImportModal extends Mixins(HasValidation) {
  // Data
  public isProcessing = false;
  public source: IImportSource | null = null;
  public form = {
    sourceId: null,
    credentialsId: null
  };

  // Methods

  public async createImport() {
    try {
      this.isProcessing = true;
      // Validate form
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");
      // Create import
      const { id }: IImport = await this.$store.dispatch(
        `data/${DataModules.IMPORTS}/createImport`,
        {
          vm: this,
          data: {
            credentials_id: this.form.credentialsId
          }
        }
      );
      // Confirmation toast
      this.$buefy.toast.open({
        message: this.$t("_sentence.imports.import_created") as string
      });
      //  Route to import
      this.$router
        .push({
          name: "adminImport",
          params: {
            importId: id
          }
        })
        .catch(err => err);
      // Close modal
      this.$emit("close");
    } catch (error) {
      this.isProcessing = false;
      // Handle error
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    }
  }
}
